import React from "react";

const BackArrowIcon = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="19"
        cy="19"
        r="18.5"
        fill="#919CB4"
        fillOpacity="0.1"
        stroke="#919CB4"
      />
      <path
        d="M16.57 12.93L10.5 19L16.57 25.07"
        stroke="#012047"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.4999 19H10.6699"
        stroke="#012047"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BackArrowIcon;
